import { FieldAPI } from '@philips-internal/oswald-ui-components';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';
import { HttpServiceResponse, PatientHttpService } from '../services/patient-http-service';

enum UsernameValidatorNames {
  REMOTE_USERNAME_VALIDATOR = 'remote-username-validator',
  MAX_AND_MIN_LENGTH_VALIDATOR = 'max-and-min-length',
}

interface CheckUserNameResponseProps {
  suggestedUsername?: string;
}

export class UsernameValidatorUtils {

  static async validateUsernameField(fieldAPI: FieldAPI, usernameException?: string): Promise<void> {
    fieldAPI.removeLocalValidator(UsernameValidatorNames.REMOTE_USERNAME_VALIDATOR);
    fieldAPI.removeLocalValidator(UsernameValidatorNames.MAX_AND_MIN_LENGTH_VALIDATOR);

    fieldAPI.addLocalValidator(UsernameValidatorNames.MAX_AND_MIN_LENGTH_VALIDATOR, value => {
      const usernameValidator = ModelService.getValidator('username-validator');
      const usernameValidatorResult = usernameValidator(value);

      return Promise.resolve(usernameValidatorResult);
    });

    if (!usernameException && !(await fieldAPI.validate())) {
      return;
    }

    if (usernameException && fieldAPI.getValue() === usernameException && await fieldAPI.validate(false)) {
      return;
    }

    if (usernameException && fieldAPI.getValue() !== usernameException && !(await fieldAPI.validate())) {
      return;
    }

    PatientHttpService.post<CheckUserNameResponseProps>(
      APPLICATION_ENDPOINTS.NEW_ACCOUNT_CHECK_USERNAME, {},
      { body: { username: fieldAPI.getValue() } }
    ).catch(({ body, status }: HttpServiceResponse<CheckUserNameResponseProps>) => {
      if (status === 422) {
        const suggestedUsername = body.suggestedUsername;
        this.addRemoteUsernameFieldLocalValidator(fieldAPI, suggestedUsername);
      }
    });
  }

  private static addRemoteUsernameFieldLocalValidator(fieldAPI: FieldAPI, suggestedUsername?: string): void {
    fieldAPI.removeLocalValidator(UsernameValidatorNames.REMOTE_USERNAME_VALIDATOR);
    fieldAPI.addLocalValidator(UsernameValidatorNames.REMOTE_USERNAME_VALIDATOR, async () => {
      const isValid = !suggestedUsername;

      const invalidMessage = suggestedUsername
        ? MessageService.translate('patient.validation-message.user-suggestion', { sugestao:  suggestedUsername })
        : MessageService.translate('patient.validation-message.invalid-user');

      return [{
        message: isValid ? '' : invalidMessage,
        name: UsernameValidatorNames.REMOTE_USERNAME_VALIDATOR,
        valid: isValid,
      }];
    });

    setTimeout(() => {
      fieldAPI.validate();
    })
  }
}